import React, { useState, useEffect } from "react";
import Axios from "axios";
import { URL_LIST_ALL } from "../configs/api";
import { useSelector } from "react-redux";
// import MUIDataTable from "mui-datatables";
import Loading from "../component/Loading";
import { Link } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import { checkRole } from "../model";
import { Table } from "react-bootstrap";
import Moment from "react-moment";
import Pagination from "react-js-pagination";

function ListToTrinh(props) {
  const parsed = window.location.search.replace('?', '');
  let { children, idrole, name, linkaction, defaultLimit, upload, params, columns, onlyList, noAction, moresearch, refresh, TopBar,listvalue } = props;
  const { user } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(1);
  const [totalResult, setTotalResult] = useState(0);
  const limit = defaultLimit ? defaultLimit : 10;
  const [totalRecord, setTotalRecord] = useState(defaultLimit ? defaultLimit : 10);
  const allowAdd = checkRole(user, idrole, 'add');

  useEffect(
    function () { 
      let mounted = true;
      if (mounted) {
        setRows([]);
        setLoading(true)
      }
      let config = {
        headers: {
          'Authorization': 'Bearer ' + user.access_token,
          'Content-Type': 'application/json; charset=UTF-8',
          'search': JSON.stringify(moresearch)
        }
      }
      Axios.get(URL_LIST_ALL + name + "?&page=" + page + "&limit=" + limit + (params ? '&' + params : '') + (parsed ? '&' + parsed : ''), config)
        .then((res) => {
          setLoading(false)
          if (res.data.status == "success") {
              setRows(res.data.data);
              setTotalResult(res.data.total)
              if(listvalue) listvalue(res.data)
              setTotalRecord(res.data.total);
          } else console.log(res.data.message);
        })
        .catch((err) => {
          console.log(err);
          
          if (mounted) setLoading(false)
        });
      return () => (mounted = false);
    },
    [name, user, page, limit, params, parsed, moresearch, refresh]
  );

  return (
    <>
    {totalResult ? "Tìm được tổng: " +totalResult + " dữ liệu" : ""}
      {loading && (<Loading />)}
      {!onlyList && <div className="d-flex justify-content-end mb-3">
        {TopBar && <>{TopBar}</>}
        {!noAction && allowAdd &&
          <Link
            to={"/add-" + (linkaction ? linkaction : name)}
            className="btn btn-success m-2"
            style={{ fontSize: 13, fontWeight: '600' }}>
            <i className="fas fa-plus-"></i> Thêm mới
          </Link>}
      </div>}
      {children}

      {columns && columns.length > 0 &&
        <>
          <Table striped bordered hover className="d-none d-sm-table">
            <thead>
              <tr>
                {columns.map((item, i) => {
                  return <th key={i}>{item.label}</th>
                })}
              </tr>
            </thead>
            <tbody>
              {rows && rows.length > 0 && rows.map((itemTr, iTr) => {
                // let idrow = itemTr.id;
                return (
                  <tr key={iTr}>

                    {columns.map((itemTd, iTd) => {
                      let result = itemTr[itemTd.name]

                      if (itemTd.options && itemTd.options.customBodyRender) {
                        const renderedValue = itemTd.options.customBodyRender(itemTr[itemTd.name], itemTr);
                        result = (renderedValue);
                      } else {
                        if (itemTd.name === 'datecreate' || itemTd.name === 'datemodified' || itemTd.name === 'datesend') {
                          if (itemTr[itemTd.name]) {
                            let time = new Date(itemTr[itemTd.name] * 1000);
                            result = <Moment format="HH:mm DD/MM/YYYY">{time}</Moment>
                          }
                        }
                      }
                      return <td key={iTd}>{result}</td>
                    })}
                  </tr>
                )
              })
              }
            </tbody>
          </Table>
          <div className="d-block d-sm-none table-mobile">
            <div className="w-100 list">
              {rows && rows.length > 0 && rows.map((itemTr, iTr) => {
                // let idrow = itemTr.id;
                return (
                  <div className="list-item shadow" key={iTr}>
                    {columns.map((itemTd, iTd) => {
                      let result = itemTr[itemTd.name]
                      if (itemTd.options && itemTd.options.customBodyRender) {
                        const renderedValue = itemTd.options.customBodyRender(itemTr[itemTd.name], itemTr);
                        result = (renderedValue);
                      } else {
                        if (itemTd.name === 'datecreate' || itemTd.name === 'datemodified' || itemTd.name === 'datesend') {
                          if (itemTr[itemTd.name]) {
                            let time = new Date(itemTr[itemTd.name] * 1000);
                            result = <Moment format="HH:mm DD/MM/YYYY">{time}</Moment>
                          }
                        }
                      }
                      return <div className="w-100 d-row d-flex" key={iTd}>
                        {(itemTd.name != "workflow_steps" && itemTd.name != "action") && <div className="item-left" >{itemTd.label}</div>}
                        <div className={(itemTd.name != "workflow_steps" && itemTd.name != "action") ? "item-right" :"w-100 p-2"}>{result}</div>
                      </div>
                    })}
                  </div>
                )
              })
              }
            </div>
          </div>
          <Pagination
            activePage={page}
            itemsCountPerPage={limit}
            totalItemsCount={totalRecord}
            pageRangeDisplayed={5}
            itemClass="page-item"
            linkClass="page-link"
            prevPageText="<"
            nextPageText=">"
            onChange={setPage}
          />
          <div className="col-12 p-5"></div>
        </>
      }
    </>
  );
}
export default React.memo(ListToTrinh)
//https://github.com/gregnb/mui-datatables